import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver signed in to a unit's ELD.
 */
export const loginV1 = tmsEventKind(
  { category: "session", kind: "login", version: 1 },
  { refs: dutyStatusChangeRefs, facts: {} },
);

export const LoginV1Schema = loginV1.schema;
export const LoginV1FactsSchema = loginV1.facts;

export type LoginV1 = z.infer<typeof LoginV1Schema>;
export type LoginV1Facts = z.infer<typeof LoginV1FactsSchema>;

/** Every version of `login`, keyed by version. What `catalog.ts` places under `session`. */
export const login = { 1: loginV1 } as const;
